import type { ImageParams } from 'components/Common/ResponsiveImage'
import type { ImageChangeHandler, ImageLoadHandler } from 'LuxKit/Carousel/BaseImageCarousel'
import type { PropsWithChildren, ReactElement } from 'react'
import { useCallback, useContext } from 'react'
import WishlistGuard from 'wishlists/components/WishlistGuard'
import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/OfferListEventsContext'
import SearchImageCarouselWrapper from './SearchImageCarouselWrapper'

const imageParams: ImageParams = {
  quality: 'best',
  fit: 'center',
  desktopWidth: '300px',
  largeDesktopWidth: '410px',
}

interface Props extends PropsWithChildren {
  bookmarkAction?: ReactElement
  images: Array<App.Image>
  productLabel?: ReactElement | false
  eagerLoadFirstImage?: boolean
  onImageChange?: ImageChangeHandler
  onImageLoad?: ImageLoadHandler
}

function _MetaSearchTileHero({
  bookmarkAction,
  images,
  productLabel,
  eagerLoadFirstImage,
  onImageChange,
  onImageLoad,
}: Props) {
  // oxlint-disable-next-line react-hooks/rules-of-hooks
  const dispatchOfferListEvent = useContext(OfferListEventsContext)

  // oxlint-disable-next-line react-hooks/rules-of-hooks
  const handleImageLoaded = useCallback<ImageLoadHandler>((index, image) => {
    dispatchOfferListEvent({ type: OfferListEvents.offerReady })
    onImageLoad?.(index, image)
  }, [dispatchOfferListEvent, onImageLoad])

  return <SearchImageCarouselWrapper
    productLabel={productLabel}
    bookmarkAction={bookmarkAction ? <WishlistGuard>{bookmarkAction}</WishlistGuard> : undefined}
    images={images}
    imageParams={imageParams}
    eagerLoadFirstImage={eagerLoadFirstImage}
    onImageChange={onImageChange}
    onImageLoad={handleImageLoaded}
  />
}

export default _MetaSearchTileHero
